export default function ({state, commit, rootState, rootGetters, dispatch}, {type, id}) {
    dispatch('clean');
    if (id) {
        type = (type && type !== 'add') ? type : 'edit';
    }
    type = type ? type : 'add';
    commit('set', {
        type,
        id: id ? id : 0,
    });
    commit('loading', true);
    switch (state.type) {
        case 'edit':
            dispatch('get', {
                id: state.id,
                cb: (data) => {
                    if (data.Certificate.PartnerLegalId) {
                        dispatch('form/get_legal', {partner: data.Certificate.PartnerId, id: data.Certificate.PartnerLegalId});
                    }
                    if(data.Reports){
                        commit('reports/data', data.Reports);
                    }
                    commit('form/data', data.Certificate);
                    if (data.PaymentData) {
                        commit('payment/loading', true);
                        dispatch('dictionaries/paymentType/select/get', {
                            cb: () => {
                                let pType = rootGetters['dictionaries/paymentType/select/list'].filter(i => {
                                    return i.value === data.PaymentData.PaymentTypeId;
                                })[0];
                                commit('payment/data', {
                                    data: data.PaymentData,
                                    category: pType.category,
                                });
                            }
                        }, {root: true});
                    }
                    commit('loading');
                }
            });
            break;
        case 'add':
            if (!rootState.user.setting.items.OwnerLegalUndefined) {
                dispatch('dictionaries/ownerLegal/select/get', {
                    cb: () => {
                        commit('form/set', {
                            OwnerLegalEntityId: rootGetters['dictionaries/ownerLegal/select/main'].value
                        });
                        commit('loading');
                    },
                }, {root: true});
            } else {
                commit('loading');
            }
            break;
        default:
            dispatch('create', {
                type: 'add',
                id,
            });
    }
}